import React from 'react';

import { fg } from '@confluence/feature-gating';
import { LoadableLazy } from '@confluence/loadable';

import type { ViewPageAttachmentForgeActionsPortalProps } from './ViewPageAttachmentForgeActionsPortal.tsx';

const ViewPageAttachmentForgeActionsPortalLoader = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ViewPageAttachmentForgeActionsPortal" */ './ViewPageAttachmentForgeActionsPortal.tsx'
			)
		).ViewPageAttachmentForgeActionsPortal,
});

ViewPageAttachmentForgeActionsPortalLoader.displayName =
	'lazy(ViewPageAttachmentForgeActionsPortal)';

export const LazyViewPageAttachmentForgeActionsPortal = ({
	contentId,
	contentType,
	isViewPage,
	spaceKey,
}: ViewPageAttachmentForgeActionsPortalProps) => {
	if (
		!isViewPage ||
		!contentId ||
		!spaceKey ||
		!contentType ||
		!fg('forge_attachment_display_conditions')
	) {
		return null;
	}

	return (
		<ViewPageAttachmentForgeActionsPortalLoader
			contentId={contentId}
			contentType={contentType}
			isViewPage={isViewPage}
			spaceKey={spaceKey}
		/>
	);
};
